module.exports = __webpack_public_path__ + "img/slider_archive.10fea61f.jpg";